import React from 'react';
import { StyledTarget } from './styled-target';

export const ResizeOrArrangeTarget = () => {
  return <StyledTarget id="resizeOrArrangeTarget" />;
};
